import React from "react";
import Button from "@source/components/UI/buttons/button/button";
import {ConsentDocument} from "@source/api/models/consentModels";
import {clinicalPresentationPath, familyPresentationPath, isClinicalOnSiteImmediatelyActiveAfterSend, isFamilyOnSiteImmediatelyActiveAfterSend, isResidentImmediatelyActiveAfterSend, residentPresentationPath} from "@source/api/models/consentHelpers";
import styles from "./consentSteps.module.scss";

export const SentConsentStep = ({document, residentId, onLater}: {
  document: ConsentDocument;
  residentId: string;
  onLater: () => void;
}) => {
  const presentResident = isResidentImmediatelyActiveAfterSend(document);
  const presentClinical = isClinicalOnSiteImmediatelyActiveAfterSend(document);
  const presentFamily = isFamilyOnSiteImmediatelyActiveAfterSend(document);
  const readyLabels = [
    presentClinical ? "the GP / Clinician" : "",
    presentFamily ? "the family member" : "",
    presentResident ? "the resident" : "",
  ].filter(Boolean);
  const readySubject = readyLabels.length <= 1
    ? (readyLabels[0] || "the resident").replace(/^the /, "The ")
    : readyLabels.length === 2
      ? `${readyLabels[0].replace(/^the /, "The ")} and ${readyLabels[1]}`
      : `${readyLabels[0].replace(/^the /, "The ")}, ${readyLabels.slice(1, -1).join(", ")}, and ${readyLabels[readyLabels.length - 1]}`;
  const sentCopy = `${readySubject} ${readyLabels.length > 1 ? "are" : "is"} ready to review this consent document on site.`;
  return <div className={styles.steps}>
    <section className={styles.sentNext}>
      <h2>Consent document sent</h2>
      <p>{sentCopy}</p>
      <div className={styles.actions}>
        <Button variant="outlined" onClick={onLater}>Present later</Button>
        {presentClinical ? <Button event="link" link={clinicalPresentationPath(residentId, document._id)}>Present to GP / Clinician now</Button> : null}
        {presentFamily ? <Button event="link" link={familyPresentationPath(residentId, document._id)}>Present to family member now</Button> : null}
        {presentResident ? <Button event="link" link={residentPresentationPath(residentId, document._id)}>Present to resident now</Button> : null}
      </div>
    </section>
  </div>;
};
